var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-default-svg-from-material-design',{attrs:{"size":_vm.size,"keep-y-zero":_vm.keepYZero,"fill-colour":_vm.fillColour,"path":"M7,10L12,15L17,10H7Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }